import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-cash-closing-data',
  templateUrl: './cash-closing-data.component.html',
  styleUrls: ['./cash-closing-data.component.scss'],
  standalone: false
})
export class CashClosingDataComponent {
  @Input() date!: string | number | Date;
  @Input() local!: string;
  @Input() user!: string;
  @Input() service!: string;
}
